// extracted by mini-css-extract-plugin
export default {"container":"Gauge_container__Omwkh","gaugeRow":"Gauge_gaugeRow__WSIq+","label":"Gauge_label__LJyqm"};